<template>
    <div class="noticeonline">
        <div class="chart" ref="chart"></div>
        <!-- <div class="echarts-item">
            <div class="chart" ref="chartSO2"></div>
            <div class="title">SO<sub>2</sub></div>
        </div>
        <div class="echarts-item">
            <div class="chart" ref="chartNOx"></div>
            <div class="title">NOx</div>
        </div>
        <div class="echarts-item">
            <div class="chart" ref="chartKlw"></div>
            <div class="title">颗粒物</div>
        </div> -->
    </div>
</template>

<script>
import { getOption } from './wasteGasSp.js';
import echarts from 'echarts';
import ECharts from "vue-echarts";
import { fontSize } from "@/util/common/fontSize"; // 字体适配

export default {
    data() {
        return {
            chartSO2: null,
            chartNOx: null,
            chartKlw: null,

            chart: null
        }
    },
    async mounted() {
        window.addEventListener("resize", this.resize);
    },
    destroyed() {
        window.removeEventListener("resize", this.resize);
    },
    methods: {
        initDraw(data) {
            const xAxisData = []
            const seriesData = []
            for (const item in data) {
                xAxisData.push(item.substring(0, 4));
                seriesData.push(Number((data[item] * 100).toFixed(2)));
            }
            this.chart = echarts.init(this.$refs.chart);
            this.chart.setOption({
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                grid: {
                    top: "10%",
                    right: "12%",
                    left: "10%",
                    bottom: "14%",
                    // containLabel: true
                },
                xAxis: [
                    {
                        type: "category",
                        data: xAxisData,

                        // axisTick: {
                        //     alignWithLabel: true
                        // },
                        // axisLabel: {
                        //     interval: 0,
                        //     rotate: 0
                        // }
                        axisLine: {
                            lineStyle: {
                                color: "rgba(255,255,255,0.12)"
                            }
                        },
                        axisLabel: {
                            margin: fontSize(12),
                            color: "#e2e9ff",
                            rotate: 25,
                            align: "center",
                            verticalAlign: "top",
                            textStyle: {
                                fontSize: fontSize(12),
                                color: "#82b0ec"
                            }
                        }
                    }
                ],
                yAxis: {
                    type: 'value',

                    axisLabel: {
                        color: '#929292'
                    },
                    splitLine: {
                        lineStyle: {
                            color: "#0B5B85",
                            type: 'dotted'
                        }
                    },
                    max: 100
                },
                series: [
                    {
                        type: "bar",
                        data: seriesData,
                        barWidth: fontSize(16),
                        showBackground: true,
                        label: {
                            normal: {
                                show: true,
                                position: "top",
                                formatter: "{c}%",
                                fontSize: fontSize(12),
                                color: '#67DCFF'
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: new ECharts.graphic.LinearGradient(
                                    1, 0, 0, 0,
                                    [
                                        {
                                            offset: 0,
                                            color: "rgba(0,244,255,1)" // 0% 处的颜色
                                        },
                                        {
                                            offset: 1,
                                            color: "rgba(0,77,167,1)" // 100% 处的颜色
                                        }
                                    ],
                                    false
                                ),
                            }
                        },
                        markLine: {
                            label: {
                                color: '#EFBE35',
                                formatter: '目标值\n{c}%',
                                align: 'center',
                                fontSize: '12px',
                                distance: [15, 0]
                            },
                            lineStyle: {
                                color: '#EFBE35',
                                type: "dashed"
                            },
                            data: [
                                {
                                    name: 'Y 轴值为 100 的水平线',
                                    yAxis: 80
                                }
                            ]
                        }
                    }
                ],

                dataZoom: [
                    {
                        type: 'inside'
                    }
                ],
            });

        },
        // initDraw(data) {
        //     let so2Data = data.map(item => {
        //         return {
        //             piValue: item.SO2.piValue,
        //             limitValue: item.SO2.limitValue
        //         }
        //     });
        //     so2Data.push({
        //         piValue: data[0].SO2.limitValue,
        //         limitValue: data[0].SO2.limitValue
        //     })
        //     let noxData = data.map(item => {
        //         return {
        //             piValue: item.NOx.piValue,
        //             limitValue: item.NOx.limitValue
        //         }
        //     });
        //     noxData.push({
        //         piValue: data[0].NOx.limitValue,
        //         limitValue: data[0].NOx.limitValue
        //     })
        //     let klwData = data.map(item => {
        //         return {
        //             piValue: item["颗粒物"].piValue,
        //             limitValue: item["颗粒物"].limitValue
        //         }
        //     });
        //     klwData.push({
        //         piValue: data[0]["颗粒物"].limitValue,
        //         limitValue: data[0]["颗粒物"].limitValue
        //     })
        //     // let xAxisData = data.map(item => item.NO2.remark);
        //     // xAxisData.push("限值")
        //     let xAxisData = ["1#炉", "2#炉", "3#炉", "限值"];
        //     //
        //     this.chartSO2 = echarts.init(this.$refs.chartSO2);
        //     this.chartNOx = echarts.init(this.$refs.chartNOx);
        //     this.chartKlw = echarts.init(this.$refs.chartKlw);
        //     let optionSO2 = getOption(so2Data, xAxisData);
        //     optionSO2.yAxis[0].max = 35;
        //     let optionNOx = getOption(noxData, xAxisData);
        //     let optionKlw = getOption(klwData, xAxisData);
        //     this.chartSO2.setOption(optionSO2);
        //     this.chartNOx.setOption(optionNOx);
        //     this.chartKlw.setOption(optionKlw);
        // },
        resize() {
            this.chart.resize()
            // this.chartSO2.resize();
            // this.chartNOx.resize();
            // this.chartKlw.resize();
        }
    }
}
</script>

<style lang="scss" scoped>
.noticeonline {
    display: grid;
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 1rem;
    width: 100%;
    height: 100%;
    color: #fff;
    padding: 1rem;
    box-sizing: border-box;

    .chart {
        width: 100%;
    }

    .echarts-item {
        width: 100%;
        height: 100%;

        .chart {
            height: calc(100% - 3rem);
            margin-bottom: 1rem;
        }

        .title {
            text-align: center;
            height: 2rem;
            line-height: 2rem;
            background: url(../../../assets/gasbg.jpg) no-repeat;
            background-size: 100% 100%;
        }
    }
}
</style>